import React, { useContext } from 'react';
import { Context } from '@front10/helpers/dist/Context';
import useStyles from '@front10/helpers/dist/UseStyles';
import Box from '../../../../components/elements/Box';
import Text from '../../../../components/elements/Text';
import { fullMonths, shortMonths } from '../../../../helpers/localization/localizationUtils';
import dayjs from 'dayjs';

type MonthCaptionProps = {
  date: Date;
  style?: React.CSSProperties;
  showYear?: boolean;
  monthFormat?: 'long' | 'short';
  monthFormatZh?: 'long' | 'short';
  monthFormatForElements?: Array<string>;
  monthSettings?: $TSFixMe;
  yearSettings?: $TSFixMe;
};

function MonthCaption(props: MonthCaptionProps) {
  const {
    date,
    showYear,
    monthFormat = 'long',
    monthFormatZh = 'short',
    monthFormatForElements = ['zh', 'zh-cn', 'zh-hk', 'zh-tw', 'zh-ca']
  } = props;
  const { direction, theme, translate, localizationData } = useContext(Context);
  const [className, style] = useStyles(
    {
      paddingBottom: '20px',
      display: 'flex',
      justifyContent: 'center',
      ...props
    },
    { direction, theme }
  );
  const dtpClassName = `${className} front10-date-selector-caption`;
  let monthsLabels =
    monthFormat === 'long'
      ? fullMonths(translate, localizationData)
      : shortMonths(translate, localizationData);

  const abbr = localizationData._config.abbr.toLowerCase();

  if (monthFormatForElements.includes(abbr)) {
    monthsLabels =
      monthFormatZh === 'long'
        ? fullMonths(translate, localizationData)
        : shortMonths(translate, localizationData);

    return (
      <Box {...props} className={dtpClassName} style={style} data-testid="calendar-month-caption">
        {showYear && (
          <Text className="front10-date-selector-caption-year">{dayjs(date).format('YYYY年')}</Text>
        )}
        <Text className="front10-date-selector-caption-month">{monthsLabels[date.getMonth()]}</Text>
      </Box>
    );
  }

  return (
    <Box {...props} className={dtpClassName} style={style} data-testid="calendar-month-caption">
      <Text className="front10-date-selector-caption-month" {...props.monthSettings}>
        {monthsLabels[date.getMonth()]}
      </Text>
      {showYear && (
        <Text className="front10-date-selector-caption-year" {...props.yearSettings}>
          {dayjs(date).format('YYYY')}
        </Text>
      )}
    </Box>
  );
}

MonthCaption.defaultProps = {
  fontSize: '4',
  textAlign: 'center',
  monthSettings: {
    marginRight: '2'
  }
};
export default MonthCaption;
